import { render, staticRenderFns } from "./CountryComponent.vue?vue&type=template&id=215606e7&scoped=true&"
import script from "./CountryComponent.vue?vue&type=script&lang=js&"
export * from "./CountryComponent.vue?vue&type=script&lang=js&"
import style0 from "./CountryComponent.vue?vue&type=style&index=0&id=215606e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215606e7",
  null
  
)

export default component.exports